import React, { PureComponent } from 'react';

import { StepBoxContainer } from './stepBox.styled';

class StepBox extends PureComponent {
  static defaultProps = {
    checked: false
  }
  
  render() {
    const { checked, className, id } = this.props;
    return (
      <StepBoxContainer checked={checked} className={className} style={{minWidth: (id === 11 || id === 12) && 160 || id === 10 && 130}}>{this.props.children}</StepBoxContainer>
    );
  }
}

export default StepBox;
